import route from "@/router/index";
import {ACCESS_TOKEN_NAME, AUTHORITIES_NAME, USER_NAME, USER_ID, EXP_TOKEN, LOCATION_CODE_NAME} from "@/constant";
import securityCfg from "@/security/config";
import { FULL_NAME, USER_POSITION } from "../constant";

const security = (function (router) {
  let userName;
  let authorities;
  let authorizationMapper;
  let authenSuccesUrlRedirect;
  let userId;

  let initAuthorities = function () {
    let authoritiesStore = getAuthoritiesStore();
    authorities = new Map();
    for (let element of authoritiesStore) {
      // let author = element.authority;
      let author = element;
      authorities.set(author, author);
    }
  }

  let initAuthorizationMapper = function () {
    authorizationMapper = [];
    cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper);
  }

  let initAuthenSuccesUrlRedirect = function () {
    authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor);
  }

  let initConfig = function () {
    initAuthorizationMapper();
    initAuthenSuccesUrlRedirect();
  }

  let initRouteFilter = function () {
    router.beforeEach((to, from, next) => {
      let _isLogin = isLogin();
      let _fullPath = to.fullPath;
      let _isAuthorized = isAuthorized(_fullPath);
      if (!_isLogin && (_fullPath === "/" || _fullPath.startsWith("/?"))) {
        next({name: 'UserLogin'});
      } else if (_isLogin && (_fullPath === "/" || _fullPath === "/authorize")) {
        next(authenSuccesUrlRedirect);
      } else if (_isAuthorized) {
        next();
      } else if (!_isLogin) {
        next({
          name: 'UserLogin'
        })
      } else {
        next({name: 'page403'});
      }
    });
  }

  let cloneObjConfig = function (origin, target) {
    for (let attr in origin) {
      target[attr] = origin[attr];
    }
  }

  let isLogin = function () {
    return authorities && authorities.size;
  }

  let hasAuthor = function (author) {
    return authorities.has(author);
  }

  let isAuthorized = function (path) {
    let _isAuthorized = true;
    for (let authorCfg of authorizationMapper) {
      if (!(authorCfg.regex instanceof RegExp)) {
        console.log('author regex path undefined');
        continue;
      }
      if (authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === "function") {
        _isAuthorized &= authorCfg.isAuthorized(hasAuthor);
      }
    }
    return _isAuthorized;
  }

  let authLogin = function (access_token, authoritiesStore, userName, exp_token, full_name , user_position) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access_token);
    localStorage.setItem(AUTHORITIES_NAME, JSON.stringify(authoritiesStore));
    localStorage.setItem(USER_NAME, userName);
    localStorage.setItem(EXP_TOKEN, exp_token);
    localStorage.setItem(FULL_NAME, full_name);
    localStorage.setItem(USER_POSITION, user_position);
    initAuthorities();
    setupUserInfor();
    initAuthenSuccesUrlRedirect();
    route.push(authenSuccesUrlRedirect);
  }

  let authLogout = function (isLogout) {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(EXP_TOKEN);
    localStorage.removeItem(FULL_NAME);
    localStorage.removeItem(USER_POSITION);
    if(!isLogout){
      isLogout = false
    }
    // localStorage.clear();
    route.push({name: 'UserLogin', query: {isLogout: isLogout}});
  }

  let getAuthoritiesStore = function () {
    let authoritiesStore;
    try {
      let _authoritiesStr = localStorage.getItem(AUTHORITIES_NAME);
      if (_authoritiesStr) {
        authoritiesStore = JSON.parse(_authoritiesStr);
      } else {
        authoritiesStore = []
      }
    } catch {
      authoritiesStore = [];
    }
    return authoritiesStore;
  }

  let getUserName = function () {
    return userName;
  }

  let getUserId = function () {
    return userId;
  }

  let setupUserInfor = function () {
    userName = localStorage.getItem(USER_NAME);
    userId = localStorage.getItem(USER_ID);
  }

  let init = function () {
    initAuthorities();
    initConfig();
    setupUserInfor();
    initRouteFilter();
  }

  init();

  return {
    roles: securityCfg.roles,
    getUserName: getUserName,
    getUserId: getUserId,
    hasAuthor: hasAuthor,
    isAuthorized: isAuthorized,
    isLogin: isLogin,
    authLogin: authLogin,
    authLogout: authLogout,
  }
})(route);

export function roles() {
  return security.roles;
}

export function getUserName() {
  return security.getUserName();
}

export function getUserId() {
  return security.getUserId();
}

export function hasAuthor(author) {
  return security.hasAuthor(author);
}

export function isAuthorized(path) {
  return security.isAuthorized(path);
}

export function authLogin(access_token, authoritiesStore, userName, exp_token, full_name, user_position) {
  return security.authLogin(access_token, authoritiesStore, userName, exp_token, full_name, user_position);
}

export function authLogout(isLogout) {
  return security.authLogout(isLogout);
}
